import React from "react";
import { Mail, LifeBuoy, ShieldCheck, Building2 } from "lucide-react";
import LegalShell, { LegalDocument } from "@/components/site/LegalShell";

const CHANNELS = [
    {
        icon: Mail,
        label: "Product enquiries",
        line: "Interested in YugOS for your business, a demo, or a partnership.",
        email: "hello@yugos.app",
    },
    {
        icon: LifeBuoy,
        label: "Technical support",
        line: "Something not working, or an existing user needs help.",
        email: "support@yugos.app",
    },
    {
        icon: ShieldCheck,
        label: "Privacy requests",
        line: "Data access, correction, or deletion under the Privacy Policy.",
        email: "privacy@yugos.app",
    },
    {
        icon: Building2,
        label: "Business enquiries",
        line: "Enterprise, integrations, press, and everything else.",
        email: "business@yugos.app",
    },
];

export default function Contact() {
    return (
        <LegalShell>
            <LegalDocument eyebrow="Contact" title="Get in touch.">
                <p className="text-zinc-600">
                    We reply to every message. Pick the channel that fits your enquiry — we
                    route each address to the right team.
                </p>

                <div className="grid sm:grid-cols-2 gap-4 not-prose">
                    {CHANNELS.map((c) => {
                        const Icon = c.icon;
                        return (
                            <a
                                key={c.email}
                                href={`mailto:${c.email}`}
                                data-testid={`contact-channel-${c.email.split("@")[0]}`}
                                className="group rounded-xl border border-zinc-200 bg-white p-5 transition-all duration-200 hover:border-zinc-300 hover:shadow-[0_8px_28px_-14px_rgba(15,23,42,0.15)] hover:-translate-y-0.5"
                            >
                                <div className="flex items-start gap-3">
                                    <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-zinc-950 text-white">
                                        <Icon className="h-4 w-4" strokeWidth={1.5} />
                                    </div>
                                    <div className="min-w-0">
                                        <div className="font-display text-[15px] font-semibold text-zinc-950 tracking-tight">
                                            {c.label}
                                        </div>
                                        <p className="mt-1 text-[13px] text-zinc-500 leading-relaxed">
                                            {c.line}
                                        </p>
                                        <div className="mt-3 font-mono text-[12.5px] text-zinc-800 group-hover:text-blue-600 transition-colors">
                                            {c.email}
                                        </div>
                                    </div>
                                </div>
                            </a>
                        );
                    })}
                </div>

                <div className="pt-2 text-[13px] text-zinc-500">
                    We aim to respond within two business days. For anything urgent, mention{" "}
                    <span className="font-mono text-zinc-700">URGENT</span> in your subject line.
                </div>
            </LegalDocument>
        </LegalShell>
    );
}
